export const PERMISSIONS = {
  PURCHASE_CREDIT: {
    codename: 'lf_invite_internal_can_purchase_credits',
    warningMessage: 'You do not have permission to add credits.',
  },
  CAN_INVITE_MEMBERS: {
    codename: 'lf_invite_internal_can_invite_members',
    warningMessage: 'You do not have permission to invite members.',
  },
  UPLOAD_TEXTURE: {
    codename: 'lf_invite_internal_can_upload_textures',
    warningMessage: 'You do not have permission to upload texture.',
  },
  DOWNLOAD_RENDER: {
    codename: 'lf_invite_internal_can_download_renders',
    warningMessage: 'You do not have permission to download render.',
  },
  DOWNLOAD_TEXTURE: {
    codename: 'lf_invite_internal_can_download_texture',
    warningMessage: 'You do not have permission to download texture.',
  },
  DOWNLOAD_MATERIAL: {
    codename: 'lf_invite_internal_can_download_material',
    warningMessage: 'You do not have permission to download material.',
  },
  CAN_MANAGE_DPI: {
    codename: 'lf_invite_internal_can_manage_dpi',
  },
  ADD_WATERMARK: {
    codename: 'lf_invite_internal_is_watermark_checkbox',
    warningMessage: 'You do not have permission to add watermark.',
  },
  CAN_CREATE_AUTOMATION: {
    codename: 'lf_invite_internal_can_create_automation',
    warningMessage: 'You do not have permission to create automation.',
  },
  CAN_USE_FAST_PREVIEW: {
    codename: 'lf_invite_internal_can_use_fastpreview',
    warningMessage: 'You do not have permission to create fast preview.',
  },
  CONFIGURATORS: {
    codename: 'lf_super_admin_can_show_v1_threesixty',
    warningMessage: 'You do not have permission to view configurators.',
  },
  SUBSCRIPTION: {
    codename: 'lf_invite_internal_can_subscription_manage',
    warningMessage: 'You do not have permission to manage subscription.',
  },
  UPLOAD_BULK_TEXTURE: {
    codename: 'lf_invite_internal_can_use_bulktexture',
    warningMessage: 'You do not have permission to upload bulk textures.',
  },
  BOOLEAN_OPERATION: {
    codename: 'lf_invite_internal_can_use_boolean_ops_curator',
    warningMessage: 'You do not have permission to perform boolean operations.',
  },
  CAN_CREATE_TILE_GROUT: {
    codename: 'lf_invite_internal_can_use_tile_and_grout',
    warningMessage: 'You do not have permission to create Tile & Grout.',
  },
  PRODUCT_CONFIGURATORS: {
    codename: 'lf_invite_internal_can_create_configurator',
    warningMessage: 'You do not have permission to view configurators.',
  },
  ADD_METADATA: {
    codename: 'lf_invite_internal_can_show_meta_data',
    warningMessage: 'You do not have permission to add metadata.',
  },
  UPDATE_CONFIGURATOR_RENDERS: {
    codename: 'lf_invite_internal_can_update_configurator_render',
    warningMessage: 'You do not have permission to update configurator renders.',
  },
  INVITED_MEMBER_CREATE_PRODUCT_GROUP: {
    codename: 'lf_invite_internal_can_create_prop_group',
    warningMessage: 'You do not have permission to create the product group.',
  },
  CAN_UPLOAD_3D_MODEL: {
    codename: 'lf_invite_internal_can_use_model_upload',
    warningMessage: 'You do not have permission to upload 3D model.',
  },
  RETAIL_AUTOMATION: {
    codename: 'lf_invite_internal_can_create_retail_automation',
    warningMessage: 'You do not have permission to create automation.',
  },
  PRODUCT_BUILDER: {
    codename: 'lf_invite_internal_can_create_product_builder',
    warningMessage: 'You do not have permission to create builder.',
  },
  PRODUCT_PAGE_V2: {
    codename: 'lf_invite_internal_product_page_v2_allowed',
    warningMessage: 'You do not have permission to see product page.',
  },
  CAN_ASSIGN_TEXTURE: {
    codename: 'lf_invite_internal_can_assign_textures',
    warningMessage: 'You do not have permission assign textures.',
  },
  DIMENSION_SHOT: {
    codename: 'lf_invite_internal_can_generate_dimension_shot',
    warningMessage: 'You do not have permission to create dimension shot.',
  },
  CAN_GENERATE_MATTRESS_RENDER_WITH_TEMPLATE: {
    codename: 'lf_invite_internal_can_generate_mattress_render_with_template',
    warningMessage: 'You do not have permission to use template in render.',
  },
  IMAGE_EDITOR: {
    codename: 'lf_invite_internal_can_edit_render_image',
    warningMessage: 'You do not have permission to edit image.',
  },
  PDP_360_IMAGE_DOWNLOAD: {
    codename: 'lf_invite_internal_can_pdp_360_download',
    warningMessage: 'You do not have permission to download images.',
  },
  REQUEST_V2_PAGE: {
    // old 3d model request page
    codename: 'lf_invite_internal_can_use_request_v2_page',
    warningMessage: 'You do not have permission to access Requests V2 page.',
  },
  CAN_CREATE_PRODUCT_PAGE_REQUEST: {
    codename: 'lf_invite_internal_can_create_product_page_request',
    warningMessage: 'You do not have permission to create product page request.',
  },
  CAN_ACCESS_IMAGINE_V2_MODEL: {
    codename: 'lf_invite_internal_can_use_imagine_ai_v2',
    warningMessage: 'You do not have permission to access imagine v2 model.',
  },
  CAN_USE_IMAGINE_SDK: {
    codename: 'lf_invite_internal_can_use_imagine_sdk',
    warningMessage: 'You do not have permission to use imagine sdk.',
  },
  CAN_UPDATE_PDP_V1_CONTENT: {
    codename: 'lf_invite_internal_can_update_pdp_v1_content',
    warningMessage: 'You do not have permission to update PDP V1 content.',
  },
  CAN_OVERWRITE_PROP_GROUP: {
    codename: 'lf_invite_internal_can_overwrite_prop_group',
    warningMessage: 'You do not have permission to overwrite the product group.',
  },
};

export const PERMISSION = Object.keys(PERMISSIONS).reduce((acc, key) => {
  acc[key] = key
  return acc
}, {});